import { render, staticRenderFns } from "./StepFixedBottom.vue?vue&type=template&id=27ae5b5c&scoped=true"
import script from "./StepFixedBottom.vue?vue&type=script&lang=js"
export * from "./StepFixedBottom.vue?vue&type=script&lang=js"
import style0 from "./StepFixedBottom.vue?vue&type=style&index=0&id=27ae5b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ae5b5c",
  null
  
)

export default component.exports